const labels = {
  calendarCtaView: 'View',
  calendarCtaViewAllEvents: 'View All Events',
  calendarCtaViewDay: 'View Day',
  calendarCtaClose: 'Close',
  datepickerFilterBtnNextMonth: 'Next month',
  datepickerFilterBtnNextWeek: 'Next week',
  datepickerFilterBtnToday: 'Today',
  datepickerFilterBtnTomorrow: 'Tomorrow',
  eventCardsCtaLearnMore: 'Learn More',
  eventCardsCtaLoadMore: 'Load More',
  eventCardsCtaViewAll: 'View All Events',
  eventCardsCtaViewDetails: 'View Details',
  eventCardsEventsUnavailable:
    'There are no scheduled events found. Please try differnt filter(s).',
  eventCardsCtaGetTickets: 'Get Tickets',
  eventCardsLabelFrom: 'From',
  filteredBarClearFilters: 'Clear Filters',
  filterLabelCategories: 'Type of Event',
  filterLabelDates: 'Pick your Dates',
  filterLabelLocations: 'Pick your Locations',
  filteredEventsBtnApply: 'Apply',
  filteredEventsBtnApplyFilter: 'Apply Filter',
  filteredEventsBtnClear: 'Clear',
  filteredEventsCategory: 'Type',
  filteredEventsDate: 'Date',
  filteredEventsLocation: 'Location',
  filteredEventsTitle: 'Explore Calendar'
}

export default labels
